module.exports = __webpack_public_path__ + "img/team.54f8c383.svg";